// Shared checkbox-styled toggle button for the activity-editor panels (field
// stripping, HR smoothing): a bordered pill with a checkmark box that fills in
// when pressed. Extracted once a second panel needed the identical markup.
export function ToggleChip({
  checked,
  onClick,
  children,
}: {
  checked: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={checked}
      className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-left text-sm transition-colors ${
        checked
          ? "border-primary/60 bg-primary/10 text-foreground"
          : "border-input bg-transparent text-muted-foreground hover:border-primary/30"
      }`}
    >
      <span
        className={`flex size-4 shrink-0 items-center justify-center rounded border ${
          checked ? "border-primary bg-primary text-primary-foreground" : "border-muted-foreground/40"
        }`}
      >
        {checked && (
          <svg viewBox="0 0 24 24" className="size-3" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </span>
      <span className="truncate">{children}</span>
    </button>
  );
}
